import { FC, ReactNode } from "react";

import { SVG_MUI } from "@ryde/assets";
import { UserEditDisplayModeEnum } from "@ryde/shared";
import { blueGreyMui, deepPurpleMui, purpleMui, rydeColors } from "@ryde/theme";

const SVG_ICON_SIZE = 18;

export const userUpdaterModes = [
  UserEditDisplayModeEnum.AlteredRides,
  UserEditDisplayModeEnum.AlteredByMeTodayRides,
  UserEditDisplayModeEnum.PassengerSelfRemoved,
  UserEditDisplayModeEnum.AlteredByMeNotTodayRides,
  UserEditDisplayModeEnum.AlteredNotByMeTodayRides,
  UserEditDisplayModeEnum.AlteredNotByMeNotTodayRides,
  UserEditDisplayModeEnum.NotAlteredRides,
  UserEditDisplayModeEnum.AllRides,
];

export const getUserEditMode = (
  isToday: boolean | undefined,
  isCurrentUser: boolean | undefined,
): UserEditDisplayModeEnum => {
  switch (true) {
    case isToday && isCurrentUser:
      return UserEditDisplayModeEnum.AlteredByMeTodayRides;
    case isToday && !isCurrentUser:
      return UserEditDisplayModeEnum.AlteredNotByMeTodayRides;
    case !isToday && isCurrentUser:
      return UserEditDisplayModeEnum.AlteredByMeNotTodayRides;
    case !isToday && !isCurrentUser:
      return UserEditDisplayModeEnum.AlteredNotByMeNotTodayRides;
    default:
      return UserEditDisplayModeEnum.NotAlteredRides;
  }
};

export const UserIconReplacement: FC = () => {
  return <div className="user-icon-replacement" />;
};

export const getUserUpdaterIcon = (
  mode: UserEditDisplayModeEnum,
): ReactNode => {
  switch (mode) {
    case UserEditDisplayModeEnum.PassengerSelfRemoved:
      return (
        <SVG_MUI.UserSelfRemovedSVG
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredRides:
      return (
        <SVG_MUI.UserPenSVG
          color={blueGreyMui._500}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredByMeRides:
      return (
        <SVG_MUI.UserPenSVG
          color={deepPurpleMui.A700}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredByMeTodayRides:
      return (
        <SVG_MUI.UserPenSVG
          color={deepPurpleMui.A700}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredByMeNotTodayRides:
      return (
        <SVG_MUI.UserPenEditOutlineSVG
          color={rydeColors.userMeNotToday}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredNotByMeTodayRides:
      return (
        <SVG_MUI.UserPenSVG
          color={purpleMui.A100}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredNotByMeNotTodayRides:
      return (
        <SVG_MUI.UserPenEditOutlineSVG
          color={rydeColors.userNotMeToday}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.AlteredNotByMeRides:
      return (
        <SVG_MUI.UserPenSVG
          color={purpleMui.A100}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    case UserEditDisplayModeEnum.NotAlteredRides:
      return (
        <SVG_MUI.UserNotAlteredSVG
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );

    default:
      return (
        <SVG_MUI.UserPenEditOutlineSVG
          color={blueGreyMui._300}
          width={SVG_ICON_SIZE}
          height={SVG_ICON_SIZE}
        />
      );
  }
};
